import Vue from 'vue'
import Vuex from 'vuex'
import Cookies from 'js-cookie'
import {Ajax, baseURL} from '@/ajax'
import {Message} from 'element-ui'
import {debounce} from 'riku-verycloud'
import Router from '../router/index'
Vue.use(Vuex)
// Vue.prototype.$Message =function(msg){
//   msg.type= msg.type=='error' ? 'warning':msg.type;
//   Message(msg)
// }
// let messagearr=['success', 'warning', 'info', 'error']
// messagearr.forEach(function (type) {
//   Vue.prototype.$Message[type] = function (options) {
//     return Message[type]({...options,'customClass': 'web_type'})
//   };
// });
// Vue.prototype.$Message.close=function(id, userOnClose){
//   return Message.close(id, userOnClose);
// }
// Vue.prototype.$Message.closeAll=function(){
//   return Message.closeAll();
// }

const storage = window.localStorage
const localStorageKey = 'jyh'
const localStorage = storage.getItem(localStorageKey) ? JSON.parse(storage.getItem(localStorageKey)) : {}

const state = {
  access_token: Cookies.get('access_token') || storage.getItem('access_token'),
  refresh_token: Cookies.get('refresh_token') || storage.getItem('refresh_token'),
  errorQueue: new Set(),
  userData: null,
  asideId: null,
  differTime: 0,
  // 游戏名称
  gameName: storage.getItem('gameName') || '',
  // 游戏图标
  gameIcon: storage.getItem('gameIcon') || '',
  //游戏Id
  gameId: storage.getItem('gameId') || '',
  
  app_id: '',
  app_name: '',
  app_icon: '',

  //筛选 右侧
  category_type: storage.getItem('category_type') || '',
  //筛选 左侧
  category_id: storage.getItem('category_id') || '',
  //搜索筛选 右侧
  category_type2: storage.getItem('category_type2') || '',
  //搜索筛选 左侧
  category_id2: storage.getItem('category_id2') || '',

  game: null,
  gameList: [],

  server_id: storage.getItem('server_id') || '',
  server_name: storage.getItem('server_name') || '',
  home_server_id: storage.getItem('home_server_id') || '',
  home_server_name: storage.getItem('home_server_name') || '',
  role_id: storage.getItem('role_id') || '',
  role_name: storage.getItem('role_name') || '',
  ac_id: storage.getItem('ac_id') || '',

  realName: storage.getItem('realName') || '',
  idNumber: storage.getItem('idNumber') || '',
  certifyId: storage.getItem('certifyId') || '',
  backurl: storage.getItem('backurl') ||'',

  // 寄售角色信息暂存
  sellInfo: storage.getItem('sellInfo') || '',
  prop_trade: storage.getItem('prop_trade') || 0,
  role_trade: storage.getItem('role_trade') || 0,
  home_active: storage.getItem('home_active') ||'',//道具市场or角色市场
  role_sort: storage.getItem('role_sort') ||'',//热门还是最新
  role_price: storage.getItem('role_price') ||'',//价格排序
  
  ac_plat: storage.getItem('ac_plat') || '',//角色筛选 平台
  ac_server_id: storage.getItem('ac_server_id') || '',//角色筛选 区服
  ac_server_name: storage.getItem('ac_server_name') || '',//角色筛选 区服
  ac_price_sx: storage.getItem('ac_price_sx') || '',//价格选择的哪一个
  min_price: storage.getItem('min_price') || '',//最低价
  max_price: storage.getItem('max_price') || '',//最高价
  goods_name: storage.getItem('goods_name') || '',//最高价

  buyAgree: storage.getItem('buyAgree') || 0,
  sellAgree: storage.getItem('sellAgree') || 0,

  puton: storage.getItem('puton') || null,

  // 搜索历史
  searchHistory: {},
  ...localStorage,
  keywords: '',

  sort: storage.getItem('sort') ||'hot',//首页 热门物品 最新上架
  cPack: storage.getItem('cPack') || 'pack', // 我的背包还是正在出售
  
  isAutoLogin: false,
  authRefreshTick: 0,
  tabactive: 0,
  otype: 0,
  isApp: false,//是否是app
  udid: '',

  market_otype: '',//market otype
  pageTitleOverride: null,
}

// history fixed
if (!state.searchHistory || state.searchHistory instanceof Array) {
  state.searchHistory = {}
}

const getters =  {
  ua() {
    const ua = navigator.userAgent.toLowerCase();
    const isTablet = /(?:iPad|PlayBook)/.test(ua)
    const isAndroid = /(?:Android)/.test(ua)
    const isIphone = /(?:iPhone)/.test(ua) && !isTablet
    const isPc = !(/ipad|iphone|midp|rv:1.2.3.4|ucweb|android|windows ce|windows mobile/.test(ua))
    // eslint-disable-next-line
    const isWechat = ua.toLowerCase().match(/MicroMessenger/i) == 'micromessenger'
    return {
      isTablet,
      isAndroid,
      isIphone,
      isPc,
      isWechat
    }
  },
  state (state) {
    return state
  },
  isLogin(state) {
    return state.access_token && state.refresh_token && true
  },
  // 是否实名认证
  isVerify() {
    return state.userData && state.userData.realName != '' && state.userData.idNumber != '' && true
  },
  isMobile: state => v => {
    return /^(13[\d]{9}$|^14[\d]{9}$|^15[\d]{9}$|^16[\d]{9}$|^17[\d]{9}$|^18[\d]{9}$|^19[\d]{9})$/.test(v)
  },
  isQQ: state => v => {
    return /[1-9][0-9]{4,}/.test(v)
  },
  rules: state => {
    return {
      mobile: [
        {required: true, message: '请输入手机号码'},
        {
          validator: (rule, value, callback) => {
            let error
            if (!store.getters.isMobile(value)) error = '手机号码格式错误'
            callback(error)
          },
          trigger: 'blur'
        }
      ],
      account: [
        {
          required: true,
          message: '请输入账户',
          // trigger: 'blur'
        }
      ],
      captcha: [
        {
          required: true,
          message: '请输入验证码',
          // trigger: 'blur'
        }
      ],
      password: [
        {
          required: true,
          message: '请输入密码'
        },
        // {
        //   min: 6,
        //   max: 20,
        //   message: '密码的长度在6～20之间'
        // }
      ],
      realName: [
        {
          required: true,
          message: '请输入真实姓名'
        },
      ],
      idNumber: [
        {
          required: true,
          message: '请填写身份证号'
        },
        {pattern: /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/, message: '身份证格式不正确'}
      ],
      cash: [
        {
          required: true,
          message: '请输入提现金额'
        },
      ],
      alipayName: [
        {
          required: true,
          message: '请输入支付宝姓名',
          trigger: 'blur'
        },
      ],
      alipayAccount: [
        {
          required: true,
          message: '请输入支付宝账号',
          trigger: 'blur'
        },
        // {
        //   validator: (rule, value, callback) => {
        //     let error
        //     if (!store.getters.isMobile(value)) error = '暂不支持手机号以外的格式'
        //     callback(error)
        //   },
          
        // }
      ],
      zfb: [
        {
          required: true,
          message: '请上传支付宝账号截图',
          trigger: 'blur'
        },
      ],
      plat: [
        {
          required: true,
          message: '请选择渠道'
        },
      ],
      goods_name: [
        {
          required: true,
          message: '请输入商品标题',
          trigger: 'blur'
        },
      ],
      price: [
        {
          required: true,
          message: '请输入价格',
        },
        {
          validator: (rule, value, callback) => {
            let error
            if(Number(value) < 100 || Number(value) > 500000) error = '100.00≤售价≤500000.00'
            callback(error)
          },
          trigger: 'blur'
        }
      ],
      qq: [
        {required: true, message: '请输入QQ号码',trigger: 'blur'},
        {
          validator: (rule, value, callback) => {
            let error
            if (!store.getters.isQQ(value)) error = 'QQ号码格式错误'
            callback(error)
          },
          trigger: 'blur'
        }
      ],
    }
  },
}
const mutations = {
  state (state, obj) {
    Object.assign(state, obj)
  },
  setPageTitleOverride(state, payload) {
    const title = payload && payload.title !== undefined && payload.title !== null ? String(payload.title) : ''
    const routeName = payload && payload.routeName ? String(payload.routeName) : ''
    state.pageTitleOverride = { title, routeName }
  },
  clearPageTitleOverride(state) {
    state.pageTitleOverride = null
  },
  changSort(state,sort) {
    state.sort = sort
    storage.setItem('sort',sort)
  },
  setAutoLogin(state, val) {
    state.isAutoLogin = val
  },
  setPack(state,pack){
    storage.setItem('cPack',pack)
    state.cPack = pack
  },
  setServiceTime(state, date) {
		let localTime = new Date();
		let serveTime = new Date(date);
		state.differTime = localTime.valueOf() - serveTime.valueOf();
	},
  setGameInfo(state,info) {
    storage.setItem('gameName',info.name)
    state.gameName = info.name
    storage.setItem('gameIcon',info.icon)
    state.gameIcon = info.icon
    storage.setItem('gameId',info.id)
    state.gameId = info.id
  },
  //綁定角色
  setBindrole(state,info) {
    storage.setItem('role_id',info.role_id)
    state.role_id = info.role_id
    storage.setItem('role_name',info.role_name)
    state.role_name = info.role_name
    // storage.setItem('server_id',info.server_id)
    // state.server_id = info.server_id
    // storage.setItem('server_name',info.server_name)
    // state.server_name = info.server_name
  },
  //綁定角色
  resetinfo(state,info) {
    storage.setItem('role_id',info.role_id)
    state.role_id = info.role_id
    storage.setItem('role_name',info.role_name)
    state.role_name = info.role_name
    // storage.setItem('server_id',info.server_id)
    // state.server_id = info.server_id
    // storage.setItem('server_name',info.server_name)
    // state.server_name = info.server_name
  },
  //绑定区服
  bindServer(state,info) {
    storage.setItem('server_id',info.server_id)
    state.server_id = info.server_id
    storage.setItem('server_name',info.server_name)
    state.server_name = info.server_name
  },
  //绑定区服
  bindAcid(state,ac_id) {
    storage.setItem('ac_id',ac_id)
    state.ac_id = ac_id
  },
  //绑定区服
  bindHomeServer(state,info) {
    storage.setItem('home_server_id',info.server_id)
    state.home_server_id = info.server_id
    storage.setItem('home_server_name',info.server_name)
    state.home_server_name = info.server_name
  },
  //重置区服
  resetServer() {
    storage.setItem('server_id','')
    state.server_id = ''
    storage.setItem('server_name','')
    state.server_name = ''
  },
  //重置区服
  resetHomeServer() {
    storage.setItem('home_server_id','')
    state.home_server_id = ''
    storage.setItem('home_server_name','')
    state.home_server_name = ''
  },
  setGameId(state,id) {
    storage.setItem('gameId',id)
    state.gameId = id
  },
  resetGameInfo(state) {
    storage.setItem('gameId','')
    state.gameId = ''
    storage.setItem('gameName','')
    state.gameName = ''
    storage.setItem('gameIcon','')
    state.gameIcon = ''
  },
  getGameInfo: debounce(async(state,id) => {
    const rs = await Ajax('game/app-list')
    state.gameList = rs.data
    if(id) {
      const game = rs.data.find(item => item.id == id)
      storage.setItem('gameId',game.id)
      state.gameId = game.id
      storage.setItem('gameName',game.app_name)
      state.gameName = game.app_name
      storage.setItem('gameIcon',game.icon)
      state.gameIcon = game.icon
    }
  }),
  changeGame(state,info) {
    state.app_id = info.id
    state.app_name = info.app_name
    state.app_icon = info.icon
  },
  //筛选右侧
  setCt(state,type) {
    storage.setItem('category_type',type)
    state.category_type = type
  },
  //筛选左侧
  setCi(state,id) {
    storage.setItem('category_id',id)
    state.category_id = id
  },
  //搜索筛选右侧
  setCt2(state,type) {
    storage.setItem('category_type2',type)
    state.category_type2 = type
  },
  //搜索筛选左侧
  setCi2(state,id) {
    storage.setItem('category_id2',id)
    state.category_id2 = id
  },

  changeGameId(state,id) {
    Cookies.set('gameId',id)
    state.gameId = id
    const game = state.gameList.find(item => item.id == state.gameId)
    state.game = game
  },
  // 实名认证
  setReal(state,obj) {
    state.realName = obj.realName
    storage.setItem('realName',obj.realName)
    state.idNumber = obj.idNumber
    storage.setItem('idNumber',obj.idNumber)
    state.certifyId = obj.certifyId
    storage.setItem('certifyId',obj.certifyId)
  },
  
  //寄售角色信息暂存
  setSell(state,obj) {
    state.sellInfo = obj
    storage.setItem('sellInfo',JSON.stringify(obj))
  },
  // 购买页 道具or角色市场
  setHome(state,obj) {
    state.prop_trade = obj.prop_trade
    state.role_trade = obj.role_trade
    storage.setItem('prop_trade',obj.prop_trade)
    storage.setItem('role_trade',obj.role_trade)
  },
//切换市场
  changeHome(state,active) {
    state.home_active = active
    storage.setItem('home_active',active)
  },
  changeRoleSort(state,sort) {
    state.role_sort = sort
    storage.setItem('role_sort',sort)
  },
  changeRolePrice(state,sort) {
    state.role_price = sort
    storage.setItem('role_price',sort)
  },
  // 价格筛选
  setPrice(state,obj) {
    state.ac_price_sx = obj.ac_price_sx
    state.min_price = obj.min_price
    state.max_price = obj.max_price
    storage.setItem('ac_price_sx',obj.ac_price_sx)
    storage.setItem('min_price',obj.min_price)
    storage.setItem('max_price',obj.max_price)
  },
  // 角色区服筛选
  setAcServer(state,obj) {
    state.ac_server_id = obj.ac_server_id
    state.ac_server_name = obj.ac_server_name
    storage.setItem('ac_server_id',obj.ac_server_id)
    storage.setItem('ac_server_name',obj.ac_server_name)
  },
  // 平台筛选
  setPlat(state,plat) {
    state.ac_plat = plat
    storage.setItem('ac_plat',plat)
  },
  setGoodsname(state,name) {
    state.goods_name = name
    storage.setItem('goods_name',name)
  },
  //全部重置
  resetAccPx() {
    state.role_price = ''
    storage.setItem('role_price','')
    state.role_sort = ''
    storage.setItem('role_sort','')
    state.role_price = ''
    storage.setItem('role_price','')
    state.ac_price_sx = ''
    state.min_price = ''
    state.max_price = ''
    storage.setItem('ac_price_sx','')
    storage.setItem('min_price','')
    storage.setItem('max_price','')
    state.ac_server_id = ''
    state.ac_server_name = ''
    storage.setItem('ac_server_id','')
    storage.setItem('ac_server_name','')
    state.ac_plat = ''
    storage.setItem('ac_plat','')
    state.goods_name = ''
    storage.setItem('goods_name','')
  },

  //交易购买协议
  changeBuyAgree(state,boolean) {
    state.buyAgree = boolean
    storage.setItem('buyAgree',boolean)
  },
  //交易出售协议
  changeBuyAgree(state,boolean) {
    state.sellAgree = boolean
    storage.setItem('sellAgree',boolean)
  },
  setPuton(state,obj) {
    state.puton = obj
    storage.setItem('puton',obj)
  },

  // 历史搜索
  changekeywords(state,keywords) {
    state.keywords = keywords
  },
  addSearchHistory(state, [key, keyword]) {
    const maxlength = 10
    let history = [...new Set([keyword, ...(state.searchHistory[key] || [])])]
    if (history.length > maxlength) {
      history = history.slice(0, maxlength)
    }
    state.searchHistory[key] = history
  },
  deleteHistory(state, [key, keyword]) {
    const set = new Set(state.searchHistory[key])
    set.delete(keyword)
    state.searchHistory[key] = [...set]
  },
  clearHistory(state, key) {
    state.searchHistory[key] = []
  },
  changeTab(state,name) {
    state.tabactive = name
  },
  changeOtype(state,name) {
    state.otype = name
  },
  watchApp(state, status) {
    state.isApp = status
  },

  setMarketOtype(state,type) {
    state.market_otype = type
  }
}
const actions = {
  setCookies: ({commit}, { access_expire, access_token, refresh_expire, refresh_token }) => {
    Cookies.set('access_token', access_token, {expires: (access_expire - new Date().getTime() / 1000) / 86400})
    Cookies.set('refresh_token', refresh_token, {expires: (refresh_expire - new Date().getTime() / 1000) / 86400})
    storage.setItem('access_token',access_token)
    storage.setItem('refresh_token',refresh_token)
    commit('state', {access_token, refresh_token})
  },
  refreshToken: async ({commit, dispatch}, refresh_token) => {
    let rs = await Ajax('login/new-refresh-token', {refresh_token}, {auth: false})
    if (rs.status == 1) {
      await dispatch('setCookies', rs.data)
      return rs.data.access_token
    }
  },
  logout: async ({commit,state}, action = 'push') => {
    for (let key of ['access_token', 'refresh_token']) {
      Cookies.remove(key)
      commit('state', {[key]: null})
    }
    commit('state', {
      userData: null,
      role_id: '',
      role_name: '',
      server_id: '',
      server_name: ''
    })
    window.localStorage.clear()
    if (!getters.ua().isPc) {
      if (getters.ua().isAndroid) {
        try {
          window.android.userLogoutWebToNative();
        } catch (error) {
          console.log(error);
        }
      } else {
        try {
          window.webkit.messageHandlers.userLogoutWebToNative.postMessage(null);
        } catch (error) {
          console.log(error);
        }
        
      }
    }
    if (action !== 'silent') {
      Message.error({
        message: '请先登录',
        duration: 2000,
        onClose: () => {
          Router.push({name: 'user.login'})
        }
      })
    }
  },
  getUserData: async ({commit,state}, cacheClear) => {
    if (cacheClear || !state.userData) {
      const rs = await Ajax('user-info/get-user-data')
      const userData = rs.data
      commit('state', {userData})
    }
  },
  pushError: ({commit ,dispatch}, error) => {
    state.errorQueue.add(error)
    dispatch('delayError',state)
  },
  delayError: debounce(() => {
    for (let msg of [...state.errorQueue]) {
      if (msg && typeof msg == 'string') {
        Message.error(msg)
      } else {
        console.warn(msg)
      }
    }
    state.errorQueue.clear()
  }, 500),
}

const storagePlugin = store => {
  store.subscribe(({ type }, { searchHistory }) => {
    if (['addSearchHistory', 'deleteHistory', 'clearHistory'].includes(type)) {
      storage.setItem(localStorageKey, JSON.stringify({
        searchHistory
      }))
    }
  })
}

const store = new Vuex.Store({
  state,
  getters,
  mutations,
  actions,
  plugins: [storagePlugin]
})
export default store
